import "../../General CSS/style.css";
import styles from '../../General CSS/Form.module.css';
import {ClaimSubmissionTemplate, createClaim} from "../../API/ClaimManager";
import React, {useState, FormEvent, ChangeEvent, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import Header from "../../Header";
import {Payee, PayeeAccount} from "../../Types/Payee";
import {getMyPayeeAccount} from "../../API/PayeeManager";

export default function CreateClaim() {
    const [payee, setPayee] = useState<Payee | null>();
    const [formData, setFormData] = useState<ClaimSubmissionTemplate>({
        amount: 0,
        reason: "",
        payeeAccount: "",
    });

    const navigate = useNavigate();

    useEffect(() => {
        getMyPayeeAccount()
            .then(response => {
                setPayee(response);
                formData.payeeAccount = response?.accounts.find(account => account.defaultAccount)?.payeeAccountUid ?? "";
            })
    }, []);

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: name === "amount" ? isNaN(parseFloat(value)) ? 0 : Math.round(parseFloat(value)*100)/100 : value,
        }));
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await createClaim(formData);
        navigate("/account/view-claims");
    }

    return (
        <>
            <Header page={"Create a Claim"} returnLink={"/account/view-claims"}/>
            <div className="content">
                <div className={styles.wrapper}>
                    <form onSubmit={handleSubmit}>
                        <div className={styles.dropdown}>
                            <label htmlFor="payeeAccount" className={styles.label}>Select an Account:</label>
                            <select id="payeeAccount"
                                    name="payeeAccount"
                                    className={styles.inputText}
                                    value={formData.payeeAccount}
                                    onChange={handleChange}
                            >
                                {payee?.accounts.map((account: PayeeAccount) => (
                                    <option key={account.payeeAccountUid}
                                            value={account.payeeAccountUid}
                                    >
                                        {account.defaultAccount ? "Default: " : ""}{account.bankIdentifier} • {account.accountIdentifier}
                                    </option>
                                ))}
                            </select>

                        </div>
                        <div className={styles.dropdown}>
                            <label htmlFor="amount" className={styles.label}>Amount (£):</label>
                            <input
                                id="amount"
                                type="number"
                                name="amount"
                                value={formData.amount}
                                onChange={handleChange}
                                step="0.01"
                                className={styles.inputText}
                            />
                        </div>
                        <div className={styles.dropdown}>
                            <label htmlFor="reason" className={styles.label}>Reason:</label>
                            <input
                                id="reason"
                                type="text"
                                name="reason"
                                value={formData.reason}
                                onChange={handleChange}
                                className={styles.inputText}
                            />
                        </div>
                        <div className={styles.submit}>
                            <input
                                type="submit"
                                className={styles.submitBtn}
                                title="Submit"
                                value="Submit"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}
